import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from 'kangarootime-ui';

const TotalsForDay = ({ total, approved, pending }) => {
  return (
    <React.Fragment>
      <Typography type='subsectionHeader' style={{ fontSize: 14 }}>Overview for selected date</Typography>
      <div className='flex-rows' style={{ justifyContent: 'space-between' }}>
        <Typography type='meta'>Total: {total}</Typography>
        <Typography type='meta'>Approved: {approved}</Typography>
        <Typography type='meta'>Pending: {pending}</Typography>
      </div>
    </React.Fragment>
  );
};

TotalsForDay.propTypes = {
  total: PropTypes.number,
  approved: PropTypes.number,
  pending: PropTypes.number
};

TotalsForDay.defaultProps = {
  total: 0,
  approved: 0,
  pending: 0
};

export default TotalsForDay;
